import graphql from "babel-plugin-relay/macro";

import { useMutationWithError } from "../../../../../../../../../../utils/hooks/useMutationWithError";
import {
  SignupMemberInput,
  useActivateAccountMutation,
  useActivateAccountMutation$data,
} from "./__generated__/useActivateAccountMutation.graphql";

export const ActivateAccountMutationString = graphql`
  mutation useActivateAccountMutation($input: SignupMemberInput!) {
    responsePayload: signupMember(input: $input) {
      success
      errors {
        code

        message
        field
      }
    }
  }
`;

export const useActivateAccount = ({
  onCompleted,
  onError,
}: {
  onCompleted: (email: string) => void;
  onError: () => void;
}) => {
  const [tryActivateAccount, isActivating] =
    useMutationWithError<useActivateAccountMutation>(
      ActivateAccountMutationString
    );

  const activateAccount = (input: SignupMemberInput) => {
    tryActivateAccount({
      variables: { input },
      onCompleted: (res: useActivateAccountMutation$data) => {
        if (res.responsePayload?.success) {
          onCompleted(input.email);
        }
      },
      onCompletedErrorCustom: (errors: any) => {
        onError();
        return errors;
      },
    });
  };

  return [activateAccount, isActivating] as const;
};
